import { API_LOCATION_URL } from 'infrastructure/config';
import { IPostInput, IPostResponse, IContactClient } from 'interfaceAdapter/gatewaySchemas/IContactClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/public/contact`;

export class ContactClient implements IContactClient {
    async post(input: IPostInput): Promise<IPostResponse> {
        const { category, name, email, content } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        const body = JSON.stringify({
            category,
            name,
            email,
            content,
        });
        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body,
            });

            const { data, message } = await response.json();

            return {
                data,
                message,
            };
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
